import styled from "styled-components";
import { type DisplayProps, display } from "styled-system";
import { theme } from "../../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const ButtonGroup = styled.div<DisplayProps>`
    width: 100%;
    margin-top: ${theme.space[3]}px;
    ${display};
`;
